import { createAction } from 'redux-act';

import { ISelectedTags, ITagData } from './tags.types';

const PREFIX = 'MARKETPLACE/TAGS';

export const loadSelectedTagsRequest = createAction<{ hashId: string }>(`${PREFIX}/LOAD_SELECTED_REQUEST`);
export const loadSelectedTagsSuccess = createAction<ISelectedTags | null>(`${PREFIX}/LOAD_SELECTED_SUCCESS`);
export const loadSelectedTagsFail = createAction(`${PREFIX}/LOAD_SELECTED_FAIL`);

export const saveSelectedTagsRequest = createAction<
  {
    hashId: string;
  } & ISelectedTags
>(`${PREFIX}/SAVE_SELECTED_REQUEST`);
export const saveSelectedTagsSuccess = createAction<ISelectedTags>(`${PREFIX}/SAVE_SELECTED_SUCCESS`);
export const saveSelectedTagsFail = createAction(`${PREFIX}/SAVE_SELECTED_FAIL`);

export const loadAvailableTagsRequest = createAction<{
  hashId: string;
}>(`${PREFIX}/LOAD_AVAILABLE_TAGS_REQUEST`);
export const loadAvailableTagsSuccess = createAction<ITagData[]>(`${PREFIX}/LOAD_AVAILABLE_TAGS_SUCCESS`);
export const loadAvailableTagsFail = createAction(`${PREFIX}/LOAD_AVAILABLE_TAGS_FAIL`);
